import { render, staticRenderFns } from "./aiWeightTongue.vue?vue&type=template&id=befe1336&scoped=true&"
import script from "./aiWeightTongue.vue?vue&type=script&lang=ts&"
export * from "./aiWeightTongue.vue?vue&type=script&lang=ts&"
import style0 from "./aiWeightTongue.vue?vue&type=style&index=0&id=befe1336&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befe1336",
  null
  
)

export default component.exports